"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importStar(require("react"));
const FormalReviewClient_1 = require("client/FormalReviewClient");
const RefetchQueryContext_1 = require("context/RefetchQueryContext");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const BannerBox_1 = __importDefault(require("components/shared/BannerBox"));
const QuotaList_1 = __importDefault(require("./QuotaList"));
const ModalSetQuota = ({ setQuotaModal, dataOptions, total, cycle, isPerfCategory, currentCalibratorId }) => {
    const [inputValue, setInputValue] = (0, react_1.useState)([]);
    const [statusCheckBox, setStatusCheckBox] = (0, react_1.useState)([]);
    const [totalSelectedPeople, SetTotalSelectedPeople] = (0, react_1.useState)(0);
    const [totalPercentagePeople, SetTotalPercentagePeople] = (0, react_1.useState)(0);
    const { refetchQueries } = (0, RefetchQueryContext_1.useRefetchQuery)();
    const onChangeCheckBox = () => {
        const tempStatusCheckBox = [];
        const tempInputValue = [];
        dataOptions.forEach((value, index) => {
            var _a;
            // @ts-ignore
            tempStatusCheckBox.push((_a = document === null || document === void 0 ? void 0 : document.getElementById(`id${index}`)) === null || _a === void 0 ? void 0 : _a.checked);
        });
        tempStatusCheckBox.forEach((checkbox, index) => {
            if (checkbox) {
                tempInputValue[index] = inputValue[index];
            }
            else {
                tempInputValue[index] = 0;
            }
        });
        setInputValue(tempInputValue);
        setStatusCheckBox(tempStatusCheckBox);
    };
    const onChangeValue = (newValue, index) => {
        const tempInputValue = [...inputValue];
        tempInputValue[index] = newValue;
        setInputValue(tempInputValue);
    };
    const closeModal = () => {
        setQuotaModal({ show: false });
    };
    const updateData = () => __awaiter(void 0, void 0, void 0, function* () {
        const params = [];
        dataOptions.forEach((value, index) => {
            if (statusCheckBox[index]) {
                params.push({
                    bottomThreshold: value.quota.bottomThreshold,
                    upperThreshold: value.quota.upperThreshold,
                    title: value.quota.title,
                    value: inputValue[index]
                });
            }
        });
        const body = {
            quota: params,
            calibratorId: currentCalibratorId
        };
        const { data } = yield (0, FormalReviewClient_1.updateQuotaCalibration)(cycle, body);
        if (data) {
            closeModal();
            refetchQueries(['calibration', 'quota']);
        }
    });
    (0, react_1.useEffect)(() => {
        const tempInputValue = [];
        const tempStatusCheckBox = [];
        dataOptions.forEach((value) => {
            if (value.quota == null) {
                tempStatusCheckBox.push(false);
                tempInputValue.push(0);
            }
            else {
                tempStatusCheckBox.push(true);
                tempInputValue.push(value.quota.value);
            }
        });
        setInputValue(tempInputValue);
        setStatusCheckBox(tempStatusCheckBox);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(() => {
        if (inputValue.length > 0) {
            const totalPeople = inputValue === null || inputValue === void 0 ? void 0 : inputValue.reduce((total, num) => total + num);
            const totalPercentage = ((totalPeople / total) * 100).toFixed(0);
            SetTotalSelectedPeople(totalPeople);
            SetTotalPercentagePeople(parseInt(totalPercentage));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);
    return (react_1.default.createElement(Modal_1.default, { minWidth: 800, customClass: "max-h-[640px]", onClose: closeModal },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Set Quota'), onClose: closeModal }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "w-full px-[24px] overflow-y-auto" },
                totalPercentagePeople > 100 && (react_1.default.createElement(BannerBox_1.default, { type: "warning", customClass: "mb-[24px]" },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        (0, HelperUtils_1.getObjectiveLocale)('Total employee'),
                        ":",
                        ' ',
                        react_1.default.createElement("span", { className: "text-r-600" }, totalSelectedPeople),
                        " /",
                        ' ',
                        total,
                        ' ',
                        react_1.default.createElement("span", { className: "text-r-600" },
                            "(",
                            totalPercentagePeople,
                            "%)",
                            ' ',
                            (0, HelperUtils_1.getObjectiveLocale)('Total quota percentage can’t exceed 100%'))))),
                react_1.default.createElement("div", { className: "flex px-[16px]" },
                    react_1.default.createElement("div", { className: "w-[10%]" }),
                    react_1.default.createElement("div", { className: "w-[30%] typography-h300 text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)('STATUS')),
                    react_1.default.createElement("div", { className: "w-[45%] typography-h300 text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)('SET QUOTA')),
                    react_1.default.createElement("div", { className: "w-[15%] typography-h300 text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)('EMPLOYEE'))),
                react_1.default.createElement("div", { className: "mt-[14px]" }, dataOptions.map((value, index) => {
                    var _a, _b;
                    const scoringMarkName = isPerfCategory
                        ? value.quota.title
                        : `${(_a = value.quota.bottomThreshold) === null || _a === void 0 ? void 0 : _a.toFixed(2)} - ${(_b = value.quota.upperThreshold) === null || _b === void 0 ? void 0 : _b.toFixed(2)}`;
                    return (react_1.default.createElement(QuotaList_1.default, { key: index, id: `id${index}`, index: index, name: scoringMarkName, inputValue: inputValue, onChangeCheckBox: onChangeCheckBox, onChangeValue: onChangeValue, statusCheckBox: statusCheckBox, total: total }));
                })))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Submit quota'),
                onClick: updateData,
                disabled: totalPercentagePeople > 100,
                dataCy: 'btn-submit-calibrate'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: closeModal,
                dataCy: 'btn-cancel-calibrate'
            }, useBorder: false })));
};
exports.default = ModalSetQuota;
